import { useApi } from "@/lib/api";
import { AdminTitle, StatusPill, Table } from "./AdminUi";

const Review = ({ status }) => <StatusPill status={status === "expert_reviewed" ? "published" : "needs_review"} />;

export default function AdminReviews() {
  const { data } = useApi("/admin/reviews");
  if (!data) return <p role="status">Loading…</p>;
  return (
    <div className="space-y-10" data-testid="admin-reviews">
      <AdminTitle title="Content reviews">Editorial record for guidance content. Nothing here has been professionally approved unless it is marked as reviewed by a named, qualified reviewer.</AdminTitle>
      <section>
        <h2 className="text-2xl mb-3">Guided journeys</h2>
        <Table head={["Journey", "Owner", "Status", "Reviewed", "Next review", "Sources", "Safeguarding notes"]} testId="reviews-journeys-table">
          {data.journeys.map((j) => (
            <tr key={j.slug} data-testid={`review-journey-${j.slug}`}>
              <td className="px-4 py-3 font-medium">{j.intro?.headline}</td>
              <td className="px-4 py-3">{j.editorial?.content_owner}</td>
              <td className="px-4 py-3"><StatusPill status="needs_review" /></td>
              <td className="px-4 py-3">{j.editorial?.reviewed_at || "Not yet"}</td>
              <td className="px-4 py-3">{j.editorial?.next_review || "To be set"}</td>
              <td className="px-4 py-3 text-xs">{(j.editorial?.sources || []).join("; ")}</td>
              <td className="px-4 py-3 text-xs">{j.editorial?.safeguarding_notes}</td>
            </tr>
          ))}
        </Table>
      </section>
      <section>
        <h2 className="text-2xl mb-3">Articles</h2>
        <Table head={["Article", "Hub", "Owner", "Review", "Reviewed", "Next review", "Safeguarding notes"]} testId="reviews-articles-table">
          {data.articles.map((a) => (
            <tr key={a.slug}>
              <td className="px-4 py-3 font-medium">{a.title}</td><td className="px-4 py-3 capitalize">{a.hub}</td>
              <td className="px-4 py-3">{a.content_owner || "Not set"}</td><td className="px-4 py-3"><Review status={a.review_status} /></td>
              <td className="px-4 py-3">{a.reviewed_at || "Not yet"}</td><td className="px-4 py-3">{a.next_review || "To be set"}</td>
              <td className="px-4 py-3 text-xs">{a.safeguarding_notes || ""}</td>
            </tr>
          ))}
        </Table>
      </section>
      <section>
        <h2 className="text-2xl mb-3">Directory entries needing verification</h2>
        <p className="text-sm text-ink-soft mb-3">Entries awaiting verification, or not checked in the last 6 months.</p>
        <Table head={["Organisation", "Verification", "Last checked", "Note"]} testId="reviews-directory-table">
          {data.directory.map((d) => (
            <tr key={d.slug}><td className="px-4 py-3 font-medium">{d.name}</td><td className="px-4 py-3"><StatusPill status={d.verification} /></td><td className="px-4 py-3">{d.last_checked || "Never"}</td><td className="px-4 py-3 text-xs">{d.admin_note}</td></tr>
          ))}
        </Table>
      </section>
    </div>
  );
}
